module.exports = __webpack_public_path__ + "static/media/snakeAI.c50495f8.webp";